import { Component, h, Prop } from '@stencil/core';
import { makeLogger } from '../../../logger/logger';
import type { labelProviderInterface } from '../../LabelProviderInterface';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/result-page/results-count/uiaas-search-results-count.tsx',
  loggersList: ['warn']
});

@Component({
  tag: 'uiaas-search-results-count',
  shadow: false,
  styleUrl: 'uiaas-search-results-count.scss',
})
export class SearchResultsCount {
    /**
     * Provides the component with current query
     */
    @Prop() readonly query;

    /**
     * Applies right-to-left-view
     * */
    @Prop() readonly rtl: boolean;

    /**
     * label provider
     */
    @Prop({ mutable: true }) labelProvider?: labelProviderInterface;

    componentWillLoad() {
        if (!this.labelProvider) {
          this.labelProvider = (name, fallback) => {
              warn(
                'Label provider not defined for the component ',
                this,
                [name, fallback]
              );
              return fallback;
          };
        }
    }

    render() {
        return (
          <div class="search__results-container">
            <uiaas-search-results-text
              query={this.query}
              labelProvider={this.labelProvider}
              rtl={this.rtl}
            />
          </div>
        );
    }
}
